export default __webpack_public_path__ + "static/media/phonepe.dea9a2fa.svg";